export enum VehicleCheckTypeLocalStorage {
  KEY = 'inspectionTypeFilterKey',
  STATUS = 'inspectionTypeFilterStatus',
  TYPE = 'inspectionTypeFilterType',
}
